import { Component, OnInit, Input } from '@angular/core';
import { AuthenticationService } from 'src/modules/base/shared/services/authentication.service';
import { BaseService } from 'src/modules/base/shared/services/base.service';

@Component({
    selector: 'app-show-status',
    templateUrl: './show-status.component.html',
    styleUrls: ['./show-status.component.scss'],
    standalone: false
})
export class ShowStatusComponent implements OnInit {
  @Input() serviceTypeCode: any;
  @Input() item: any
  @Input() paymentStatus: any
  @Input() fields: Array<any>
  userType: any
  statusResource: any;

  constructor(    
    private authenticationService: AuthenticationService,
    private baseService: BaseService
  ) { }

  ngOnInit() {
    // console.log('item is as',this.item);
    this.userType = this.authenticationService.getUserType();
    this.setFields(this.fields)
    // this.getRequestHistory(this.item.id)
  }


  setFields(fields) {
    //uncomment to enable order by json 
    // let statusResource = this.validConditions(fields);
    // this.statusResource = statusResource.sort((a, b) => { return a.order - b.order });
    this.statusResource = this.validConditions(fields);
  }

  validConditions(fields) {
    if (fields) {
      fields.forEach(field => {
        if (field.statusConditions && field.statusConditions.length > 0) {
          let status = this.isExpressionValid(field.statusConditions);
          if (status == -1)
            field['status'] = true
          else
            field['status'] = false
        }
        else {
          field['status'] = true
        }

        if (field.fieldConditions && field.fieldConditions.length > 0) {
          let valid = this.isExpressionValid(field.fieldConditions);
          if (valid == -1)
            field['valid'] = true
          else
            field['valid'] = false
        }
        else {
          field['valid'] = true
        }
      })
    }
    return fields
  }

  isExpressionValid(conditions) {
    let result = [];
    let item = this.item
    conditions.forEach(exp => {
      result.push(eval(exp.expression))
    })
    return result.indexOf(false)
  }
  getRequestHistory(serviceRequestId){
    let data = {
      filter: "serviceRequestId:"+serviceRequestId
    }

    // this.baseService.getData(data,'','service_request_history','order').subscribe((res)=>{
    //   console.log('service_request_history is as ',res)
    // })
  }

}
